import { usePatientPlanType } from 'hooks/usePatientPlanType'

/*
  TODO: Remover implementação após o backend implementar a lógica

  Essa implementação é uma v0 (https://app.clickup.com/t/86a640vag), o intuito é que depois o produto REDE+ seja sistematizado e essa lógica venha
  do backend, por enquanto é uma solução para o MVP.

  A ideia é que o paciente tenha acesso a um conteúdo específico no Circle de acordo com o seu plano:
   - Enterprise e Particular: Mesma mensagem de descrição no card e url do circle
   - Corporate: Será tratado como REDE+ e verá a mesma mensagem no card que os planos de CC mas tem uma url específica no Circle
   - Cuidado Coordenado (Capitation): Mensagem no card compartilhada com Corporate e url específica no Circle
*/

const urls = {
  enterprise: process.env.REACT_APP_CIRCLE_URL_ENTERPRISE,
  corporate: process.env.REACT_APP_CIRCLE_URL_CORPORATE,
  capitation: process.env.REACT_APP_CIRCLE_URL_CAPITATION
}

const texts = {
  default: 'Tenha acesso a técnicas e ferramentas práticas de saúde mental e rodas de conversa ao vivo. Cadastre-se gratuitamente e confira.',
  plus: 'Tenha acesso a técnicas e ferramentas práticas de saúde mental, palestras e rodas de conversa ao vivo. Cadastre-se gratuitamente e confira.'
}

export function useContent(): { url: string, text: string } {
  const { isEnterprise, isCorporate, isParticular, isCapitation } = usePatientPlanType()
  const isDefaultPlanType = isEnterprise || isParticular

  /*
    Texto default do card é o mesmo para Enterprise e Particular.
    Já o texto plus é para Corporate e Capitation pois possuem acesso a palestras no Circle.
  */
  const text = isDefaultPlanType ? texts.default : texts.plus
  
  const urlHandler = () => {
    if (isDefaultPlanType) return urls.enterprise
    if (isCorporate) return urls.corporate
    if (isCapitation) return urls.capitation

    return urls.enterprise
  }

  return {
    url: urlHandler(),
    text
  }
}
